export type PixQrExpirationOption = {
  value: string
  label: string
}

export const PIX_QR_EXPIRATION_OPTIONS: PixQrExpirationOption[] = [
  { value: '', label: 'Ilimitado' },
  { value: '15', label: '15 minutos' },
  { value: '30', label: '30 minutos' },
  { value: '45', label: '45 minutos' },
  { value: '60', label: '60 minutos' },
  { value: '120', label: '2 horas' },
  { value: '180', label: '3 horas' },
  { value: '240', label: '4 horas' },
]

export function pixQrExpirationMinutesToFormValue(
  minutes: number | string | null | undefined,
): string {
  if (minutes == null || minutes === '') {
    return ''
  }

  const parsed = typeof minutes === 'number' ? minutes : parseInt(String(minutes), 10)
  if (!Number.isFinite(parsed)) {
    return ''
  }

  const value = String(parsed)
  const isAllowed = PIX_QR_EXPIRATION_OPTIONS.some((option) => option.value === value)

  return isAllowed ? value : ''
}
